module.exports = __webpack_public_path__ + "img/public/SiteIcons/exportIcon.svg?9e41a602";